const projects = [
    {
        id: 1,
        title: "Diet Delivery",
        name: "diet-delivery",
        summary: "",
        role: "I contributed to every aspect of this team project, including all front end and back end components.",
        tools: ["CSS", "NodeJS", "MySQL","Handlebars"],
        description: "A web application for a meal delivery service that specializes in diets for chronic diseases, such as renal disease and diabetes.",
        url: "https://diet-delivery.herokuapp.com/",
        github: "https://github.com/MikeGShelby/diet-delivery",
        featured: true
    },
    {
        id: 2,
        title: "Tech Blog",
        name: 'tech-blog',
        summary: "",
        role: "",
        tools: ["CSS", "NodeJS", "MySQL","Handlebars"],
        description: "A CMS-style blog site that allows users to create a user account, log into their user account, publish blog posts, and comment on other users' blog posts.",
        url: "https://tech-blog-h.herokuapp.com/",
        github: "https://github.com/MikeGShelby/tech-blog",
        featured: true
    },
    {
        id: 3,
        title: "CinaSearch",
        name: 'cinasearch',
        summary: "",
        role: "My main contribution to this team project was front-end layout and design using Bulma and CSS.",
        tools: ["JavaScript", "Bulma"],
        description: "A movie search application that retrieves movie-related data from the OMDb and Youtube APIs.",
        url: "https://mikegshelby.github.io/cinasearch/",
        github: "https://github.com/MikeGShelby/cinasearch",
        featured: true
    },
    {
        id: 4,
        title: "Fit Club",
        name: 'fit-club',
        summary: "",
        role: "",
        tools: ["CSS", "NodeJS", "GraphQL", "MongoDB", "React"],
        description: 'A social fitness application that connects fitness enthusiasts and fitness professionals. The application allows users to share fitness goals and related information with other users and with trainers.',
        url: "https://fit-clob.herokuapp.com/",
        github: "https://github.com/maxhealy01/fit-club",
        featured: false
    },
    {
        id: 5,
        title: "Weather Dashboard",
        name: 'weather-dashboard',
        summary: "",
        role: "",
        tools: ["CSS", "JavaScript", "JQuery"],
        description: 'A weather dashboard application that features dynamically updated HTML and CSS. Weather data is obtained through the OpenWeather API.',
        url: "https://mikegshelby.github.io/weather-dashboard/",
        github: "https://github.com/MikeGShelby/weather-dashboard",
        featured: false
    },
    {
        id: 6,
        title: "Password Generator",
        name: 'password-generator',
        summary: "",
        role: "",
        tools: ["CSS", "JavaScript"],
        description: 'A password generator application that generates a secure, random password after prompting the user to select from multiple password character criteria.',
        url: "https://mikegshelby.github.io/password-generator/",
        github: "https://github.com/MikeGShelby/password-generator",
        featured: false
    },
    {
        id: 7,
        title: "Deep Thoughts",
        name: 'deep-thoughts',
        summary: "",
        role: "",
        tools: ["CSS", "NodeJS", "MongoDB", "React"],
        description: 'A MERN stack social media application that allows users to add other users to a friend list and to post thoughts and reactions for others to view and interact with.',
        url: "https://deep-thoughts-hk.herokuapp.com/",
        github: "https://github.com/MikeGShelby/deep-thoughts",
        featured: false
    },
    {
        id: 8,
        title: "Work Day Scheduler",
        name: 'work-day-scheduler',
        summary: "",
        role: "",
        tools: ["JQuery", "Bootstrap"],
        description: 'A simple calendar application that allows a user to save events for each hour of the day.',
        url: "https://mikegshelby.github.io/work-day-scheduler/",
        github: "https://github.com/MikeGShelby/work-day-scheduler",
        featured: false
    },
    {
        id: 9,
        title: "Book Search Engine",
        name: 'book-search-engine',
        summary: "",
        role: "",
        tools: ["CSS", "GraphQL", "NodeJS", "MongoDB"],
        description: 'A MERN stack search engine application that retrieves data from the Google Books API.',
        url: "https://book-search-engine-h.herokuapp.com/",
        github: "https://github.com/MikeGShelby/book-search-engine",
        featured: false
    },
];

export default projects;